export default "__VITE_ASSET__19d24279__"